import { Either, isLeft, left, right } from "fp-ts/lib/Either";
import di from "../../../../DependencyInjection";
import QrRepository, { QrRepositoryName } from "../../../../domain/repositories/QrRepository";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const createQrsInBatchApiImpl = async (quantity: number, stablishmentId: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const relativeUrl = `/qrcodes/generate?number=${quantity}&stablishment_id=${stablishmentId}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        if (isLeft(response)) {
            return left({
                code: "Error creando lote de QRs",
            });
        }
        const responseDownload = await di.get<QrRepository>(QrRepositoryName).downloadQrBatch(response.zip_token);
        if (isLeft(responseDownload)) {
            return left({ 
                code: KeyWordLocalization.SuccessDownloadWithErrors,
                message: "Qr's creados, pero fallo la descarga del lote, intenta de nuevo desde la interfaz"
            });
        }
        return right(undefined);
    } catch (error) {
        return left({
            code: "Error creando lote de QRs",
        });
    }
};


export default createQrsInBatchApiImpl;